var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['deals-status', _vm.getModify(_vm.statusId)]},[_c('div',{staticClass:"deals-status__icon"},[_c(_vm.getIcon(_vm.statusId),{tag:"component"})],1),_c('div',{staticClass:"deals-status__text"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }